import React from "react";
import CustomSkeletonTable from "../../../../ui/CustomSkeletonTable/CustomSkeletonTable";
import PermissionsTableTanstack from "../../tables/PermissionsTableTanstack";
import PermissionEmptyState from "./PermissionEmptyState";

const PermissionTableContent = ({
  loadingData,
  noPermissions,
  noResults,
  filteredPermissions,
  onEdit,
  onDelete,
}) => {
  if (loadingData) {
    return <CustomSkeletonTable columns={[1, 2, 3]} rowCount={10} />;
  }

  if (noPermissions || noResults) {
    return (
      <PermissionEmptyState
        noPermissions={noPermissions}
        noResults={noResults}
      />
    );
  }

  return (
    <PermissionsTableTanstack
      data={filteredPermissions}
      onEdit={onEdit}
      onDelete={onDelete}
      loading={loadingData}
    />
  );
};

export default PermissionTableContent;
